import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2';
import Nim from '@/utils/NIM_Web_SDK_v8.9.116' // 网易im
Vue.prototype.NIM = Nim.NIM
import ElementUI from 'element-ui';
import Input from '@/components/Input'
import Empty from '@/components/Empty'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/font.css';
import 'tui-image-editor/dist/tui-image-editor.css'
import 'tui-color-picker/dist/tui-color-picker.css'

const whiteList = ['/login', '/sign', '/reset']
router.beforeEach((to, from, next) => {
  var member = localStorage.getItem("member")
  if (member) {
    member = JSON.parse(member);
    if (whiteList.indexOf(to.path) === -1 && member.is_perfect == 0) next({ path: '/sign' })
    else next()
  } else {
    next()
  }
})
Vue.component('Input',Input)
Vue.component('Empty',Empty)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueClipboard)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
